import { Pipe, PipeTransform } from '@angular/core';

/** Map of UserRole to display string */
export const UserRoleMap = {
    BusinessOffice: "BusinessOffice",
    Corporate: "Corporate",    
    DON: "DON", // Director of Nursing
    DrugPriceQuote: "DrugPriceQuote",
    InvoiceApproval: "InvoiceApproval",
    Nurse: "Nurse",    
    UserAdministration: "UserAdministration"
};

/** String literal type from the keys of UserRoleMap. Easier to work with than enum. */
export type UserRole = keyof typeof UserRoleMap;

/** All available UserRole values */
export const UserRoles: string[] = Object.keys(UserRoleMap);

/**
 * Translate a UserRole into a display name.
 */
@Pipe({name: 'myUserRole'})
export class MyUserRolePipe implements PipeTransform {
    transform(value: UserRole | string) {
        // Currently, display name and value are the same. That could change though.
        //return UserRoleMap[value] || "Unknown/"+value;
        let result = value.toString().replace(/([A-Z]+)/g, ' $1').trim()
        return result;
    }
}


/**
 * Model an application user.
 */
export class User {
    username: string;
    loginName: string;
    name: string;
    firstName: string;
    lastName: string;
    role: UserRole[];
    email: string;
    id: string;
    phoneNumber: string;
    needPasswordChange?: boolean;
    userTimeZone: string;

    /** Is this a corporate user impersonating another user? */
    isImpersonating?: boolean;

    isSSOLogin?: boolean;

    ssoRedirect: string;

    /** JSON Web Token */
    jwt?: {access_token: string, refresh_token: string};
}
